import { render, staticRenderFns } from "./UnacknowledgedPackages.vue?vue&type=template&id=6213a651&"
import script from "./UnacknowledgedPackages.vue?vue&type=script&lang=js&"
export * from "./UnacknowledgedPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports